import { fetch } from "@deere/scs-fetch";
import { URL_SUBTIER_API } from '../utils/constEnvVariables'

/*CR2-75
    * Author: RAZ9N14:
    * Methof to  post subtier data */
export const saveSubtierRecords = async (accessToken,goldenRecord) => {
    return fetch(`${URL_SUBTIER_API}/cleansing/golden-records`,{
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(goldenRecord)
        }).then((res) => {
            return res;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });
}

export const deleteSubtier = async function (subtierSupplierNo,accessToken) {
    return fetch(`${URL_SUBTIER_API}/cleansing/golden-records?subtierNumber=${subtierSupplierNo}`,{
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
        }).then((res) => {
            return res;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });
}